import LeasingSearch from "./components/LeasingSearch.vue";
Vue.component('leasing-search', LeasingSearch)

const leasingSearchVueEnvironment = new Vue({
    delimiters: ['[%', '%]'],
    el: '.leasingSearchListing',
});